import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { CategoryListResponse } from '../../common/types/types'

const initialState: { data: CategoryListResponse } = {
  data: {
    data: [],
    total: 0,
  },
}

export const categoryListSlice = createSlice({
  name: 'category-list',
  initialState,
  reducers: {
    setCategoryList: (state, action: PayloadAction<CategoryListResponse>) => {
      state.data = { ...action.payload }
    },
  },
})

export const { setCategoryList } = categoryListSlice.actions

export const selectCategoryList = (state: RootState) => state.categoryList.data.data

export const selectCategoryItem = (id: number) =>
  createSelector(
    [selectCategoryList],
    (categories) => categories.find((el) => el.id === id)
  )

export default categoryListSlice.reducer